import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseMaterialReleaseActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/MaterialRelease/MaterialReleaseBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseMaterialRelease"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseMaterialRelease"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseMaterialReleaseActivity)
